import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-circle-disable",
  "use": "icon-circle-disable-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-circle-disable\"><path fill-rule=\"evenodd\" d=\"M2 10c0-4.467 3.533-8 8-8s8 3.533 8 8-3.533 8-8 8-8-3.533-8-8m8-10C4.429 0 0 4.429 0 10s4.429 10 10 10 10-4.429 10-10S15.571 0 10 0m5 9H5v2h10z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol